export default "__VITE_ASSET__CUQgpGz6__"